/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Background_HelpInputs */



/**
* | output |
* | --- |
* | "The original mix without dialogue." |
*
* @param {Audio_Stems_Background_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_background_help = /** @type {((inputs?: Audio_Stems_Background_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Background_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le mixage original sans dialogues.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Originalmischung ohne Dialog.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il mix originale senza dialoghi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный микс без диалогов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La mezcla original sin diálogos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不含对白的原始混音。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("台詞を除いた元のミックス。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद के बिना मूल मिक्स।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A mistura original sem diálogo.")
	return /** @type {LocalizedString} */ ("The original mix without dialogue.")
});